import { render, staticRenderFns } from "./LogsView.vue?vue&type=template&id=b24998d8&scoped=true&"
import script from "./LogsView.vue?vue&type=script&lang=js&"
export * from "./LogsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24998d8",
  null
  
)

export default component.exports